module.exports = __webpack_public_path__ + "img/IMG_7268.6f1527d5.jpg";